import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../Base/Components/BaseModal/BaseModal';
import InsuranceUploadReturnedBatch from './InsuranceUploadReturnedBatch';

interface Props extends BaseModalProps {
	workplaceId: string;
	onSuccess: () => void;
}

const InsuranceUploadReturnedBatchModal: React.FC<Props> = props => {
	return (
		<BaseModal
			{...props}
			title='component.insuranceUploadReturnedBatch.modalTitle'>
			<InsuranceUploadReturnedBatch
				workplaceId={props.workplaceId}
				onSuccess={props.onSuccess}
			/>
		</BaseModal>
	);
};

export default InsuranceUploadReturnedBatchModal;
